import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../providers/AuthContextProvider";
import { LoggedRecruiter } from "../../models/LoggedRecruiter";
import { Link, useNavigate } from "react-router-dom";
import { MenuItem } from "../../models/MenuItem";
import { StyleContext } from "../../providers/StyleContextProvider";
import { useMediaQuery } from "react-responsive";
import { DropdownItem } from "./DropdownItem";
import { ReactComponent as MobileMenu } from '../../assets/svg/mobile_menu.svg';
import { ReactComponent as LeftArrow } from '../../assets/svg/left_arrow.svg';
import { Button } from "./Buttons/Button";
import { XpressJobsTitle } from "./XpressJobsTitle";
import { DesktopMenu } from "./DesktopMenu";
import { MobileMenuDrawer } from "./MobileMenuDrawer";
import { ProfileEntrance } from "../Home/ProfileEntrance";
import { LoggedCandidate } from "../../models/LoggedCandidate";
import { getHost } from "../../helpers/Common";

interface Props {
    recruiterLoginEnable?: boolean;
    isBackButtonHidden?: boolean;
}

export const RecruiterHeader: React.FC<Props> = (props) => {
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const candidate: LoggedCandidate | null = authContext.getLoggedCandidate();
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState(styleContext.getComponentStyle("recruiterHeader"));
    const [mobileMenuToggle, setMobileMenuToggle] = useState<boolean>(false); 
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const baseURL = getHost();    

    useEffect(() => {
        setStyles(styleContext.getComponentStyle("recruiterHeader"));
    }, [isMobile]);

    const redirectByUser = () => {
        if(candidate !== null) {                        
            navigate('/candidate/home', { state: { candidateId: candidate.candidateId }});
        } 
        else if(recruiter !== null) {                        
            navigate('/recruiter/vacancy', { state: { recruiterId: recruiter.recruiterId }});
        } 
        else {                        
            navigate('/');
        } 
    }

    const handleRecruiterLogin = () => {
        navigate('/recruiter/account/login');    
    }
    
    const handleJobSeekerLogin = () => {        
        navigate('/candidates/login');        
    }
        
    const handleMobileMenuToggle = () => {        
        setMobileMenuToggle((prev) => !prev);
    }

    const menuItems: MenuItem[] = [
        { isList: false, item: <span onClick={redirectByUser} style={styles.label}>{"Home"}</span> },
        { isList: false, item: <span onClick={() => window.location.assign(baseURL + "for-recruiters#content")} style={styles.label}>{"Features"}</span> },
        { isList: false, item: <span onClick={() => window.location.assign(baseURL + "for-recruiters#campaigns")} style={styles.label}>{"Campaign"}</span> },
        { isList: false, item: <span onClick={() => window.location.assign(baseURL + "for-recruiters#pricing-table")} style={styles.label}>{"Pricing"}</span> },
        { isList: false, item: <span onClick={() => window.location.assign(baseURL + "for-recruiters#faq")} style={styles.label}>{"FAQs"}</span> },
        { isList: true, label: "More", styles: styles.desktopMenu.more, items: [] = [
            { item: 
                <Link to={"/testimonials/recruitment"} style={styles.dropdownLabel}>
                    <DropdownItem styles={styles.dropdownItem}>{"Testimonials"}</DropdownItem>
                </Link>                
            },
            { item: 
                <Link to={"/press"} style={styles.dropdownLabel}>
                    <DropdownItem styles={styles.dropdownItem}>{"Press Releases"}</DropdownItem>
                </Link>                    
            },
            { item:
                <Link to={"/home/preferredPartners"} style={styles.dropdownLabel}>
                    <DropdownItem styles={styles.dropdownItem}>{"Partners"}</DropdownItem>
                </Link>                    
            },
            { item:
                <Link to={"/home/differentlyabledfriendlyemployment"} style={styles.dropdownLabel}>
                    <DropdownItem styles={styles.dropdownItem}>{"Differently Abled Friendly Employment"}</DropdownItem>
                </Link>                    
            }]
        }
    ]

    return (        
        <div style={styles.header}>            
            {/* This is loading only mobile platform */}
            <MobileMenuDrawer open={mobileMenuToggle} toggle={handleMobileMenuToggle} menuItems={menuItems} recruitersLogin={handleRecruiterLogin} jobSeekersLogin={handleJobSeekerLogin} candidate={candidate} recruiter={recruiter} />            
            <div style={styles.row}>
                <XpressJobsTitle style={styles.title} />                
                {!props.isBackButtonHidden && <div style={styles.backButton.wrapper} onClick={() => navigate(-1)}>
                    <Button style={styles.backButton.button}><LeftArrow style={styles.backButton.icon} /></Button>
                    <span style={styles.backButton.text}>{"Back"}</span>
                </div>}             
                {/* This is loading only desktop platform */}
                <DesktopMenu menuItems={menuItems} />                
                {(!candidate && !recruiter) ? <div style={styles.loginWrapper}>                        
                    <Button type="button" style={styles.jobSeekersButton} onClick={handleJobSeekerLogin}>{"JOB SEEKER LOGIN"}</Button>
                    {props.recruiterLoginEnable &&
                    <Button type="button" style={styles.recruitersButton} onClick={handleRecruiterLogin}>{"RECRUITER LOGIN"}</Button>}
                </div> : <div style={styles.profileWrapper}><ProfileEntrance isRecruiterHeader={true} candidate={candidate} recruiter={recruiter} /></div>}
                <Button type="button" style={styles.mobileMenuButton} onClick={handleMobileMenuToggle}><MobileMenu/></Button>
            </div>            
        </div>
    );
}